// External packages
import { z } from 'zod';

// Components
import { FileInputField } from 'components/FileInput';
import { Button } from 'components/Button';
import * as Modal from 'components/Modal';
import { Form } from 'components/Form';

const audioFormSchema = z.object({
  audio: z.instanceof(File).refine((file) => file instanceof File, {
    message: 'Unesite audio',
  }),
});

type AddAudioModalProps = {
  onSubmit: (data: z.infer<typeof audioFormSchema>) => Promise<void> | void;
  modalTrigger?: React.ReactNode;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  isPending?: boolean;
};

export const AddAudioModal: React.FC<AddAudioModalProps> = ({
  onSubmit,
  modalTrigger,
  isOpen,
  onOpenChange,
  isPending = false,
}) => {
  return (
    <Modal.TriggerRoot isOpen={isOpen} onOpenChange={onOpenChange}>
      {modalTrigger}
      <Modal.Overlay isDismissable>
        <Modal.Root>
          <Modal.Dialog>
            <Modal.Close />
            <h3 className="mb-8 text-2xl text-gray-600">Dodaj audio</h3>
            <Form schema={audioFormSchema} onSubmit={onSubmit}>
              <FileInputField
                fileTriggerProps={{
                  acceptedFileTypes: [
                    'audio/mpeg',
                    'audio/mp3',
                    'audio/wav',
                    'audio/ogg',
                  ],
                }}
                label="Audio"
                name="audio"
              />
              <Button
                type="submit"
                className="mt-12 w-full"
                size="lg"
                isPending={isPending}
              >
                Dodaj audio
              </Button>
            </Form>
          </Modal.Dialog>
        </Modal.Root>
      </Modal.Overlay>
    </Modal.TriggerRoot>
  );
};
